import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export default function ForgotPassword() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md py-10">
      <div className="label-caps mb-2">{t("forgot_password_title")}</div>
      <h1 className="mb-6 text-3xl font-bold tracking-tight">{t("forgot_password")}</h1>
      <Card className="border-border">
        <CardContent className="p-6">
          {sent ? (
            <div className="space-y-4" data-testid="forgot-password-sent">
              <div className="rounded-md border border-primary/30 bg-primary/5 px-3 py-3 text-sm text-primary">
                {t("forgot_password_sent")}
              </div>
              <Link
                to="/login"
                className="block text-center text-sm text-primary underline-offset-4 hover:underline"
                data-testid="back-to-login-link"
              >
                {t("back_to_login")}
              </Link>
            </div>
          ) : (
            <form className="space-y-4" onSubmit={submit}>
              <p className="text-sm text-muted-foreground">{t("forgot_password_hint")}</p>
              <div>
                <Label htmlFor="email">{t("email")}</Label>
                <Input
                  id="email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-password-email-input"
                />
              </div>
              {error && (
                <div
                  className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive"
                  data-testid="forgot-password-error"
                >
                  {error}
                </div>
              )}
              <Button
                type="submit"
                className="w-full"
                disabled={loading}
                data-testid="forgot-password-submit-btn"
              >
                {loading ? "…" : t("send_reset_link")}
              </Button>
              <div className="text-center text-sm">
                <Link
                  to="/login"
                  className="text-primary underline-offset-4 hover:underline"
                  data-testid="back-to-login-link"
                >
                  {t("back_to_login")}
                </Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
